import React from 'react'
import {CreditCardTypeIcon} from '../../../components/credit-card-type-icon'
import {CheckIcon} from '../../../components/icons'
import {CARD_TYPES, CARD_TYPES_CODE} from '../../../utils/constants'
import {Flex, Text} from '../../../vanilla'
import * as styles from '../styles.css'
import {toSlug} from '../../../utils/utils'

interface PaymentMethodProps {
  method: string
  checked: boolean
  onClick: () => void
  type: string
  customIconURL?: string
}

export const PaymentMethod = ({
  method,
  checked,
  onClick,
  type,
  customIconURL
}: PaymentMethodProps) => {
  const selectorName = toSlug(method, true)
  
  return (
    <Flex
      className={styles.paymentMethodBox}
      align="center"
      justify="space-between"
      cursor="pointer"
      onClick={() => onClick()}
      width="full"
    >
      <Flex gap="12px" align="center">
        <Flex
          width="20px"
          height="20px"
          border="1px"
          borderColor={checked ? 'accent3' : 'gray200'}
          borderRadius="full"
          bg={checked ? 'accent3' : 'gray25'}
          align="center"
          justify="center"
        >
          {checked && <CheckIcon width="12px" height="12px" color="white" />}
        </Flex>
        <Text variant="text4" lineHeight="shorter" data-cs-mask="">
          {method}
        </Text>
      </Flex>
      <Flex gap="12px" align="center">
        <CreditCardTypeIcon customURL={customIconURL} cardType={type as CARD_TYPES_CODE} />
      </Flex>
    </Flex>
  )
}

interface PaypalVaultedPaymentMethodProps {
  email: string
  checked: boolean
  onClick: () => void
}

export const PaypalVaultedPaymentMethod = ({email, checked, onClick}: PaypalVaultedPaymentMethodProps) => {
  return (
    <Flex
      className={styles.paymentMethodBox}
      align="center"
      justify="space-between"
      borderRadius="base"
      cursor="pointer"
      onClick={() => onClick()}
    >
      <Flex gap="12px" align="center">
      <Flex
        width="20px"
        height="20px"
        border="1px"
        borderColor={checked ? 'accent3' : 'gray200'}
        borderRadius="full"
        bg={checked ? 'accent3' : 'gray25'}
        align="center"
        justify="center"
      >
        {checked && <CheckIcon width="12px" height="12px" color="white" />}
        
      </Flex><Text variant="text3" lineHeight="shorter" data-cs-mask="">
          {email}
        </Text>
        </Flex>
      <Flex align="center">
        <CreditCardTypeIcon cardType={CARD_TYPES.PAYPAL} />
      </Flex>
    </Flex>
  )
}
